import { BaseUrl } from "./APIURL";

// http://192.168.195.102:8083/dairy-warna/transaction/labReportEntry/getLabReportEntryByUniqueId?uniqueId=${uniqueId}
export const getLabDetailsByUniqueIdAPIURL = BaseUrl + "/transaction/labReportEntry/getLabReportEntryByUniqueId";

//http://192.168.195.102:8083/dairy-warna/transaction/labReportEntry/getLabReportEntryList
export const getLabDetailsAPIURL = BaseUrl + "/transaction/labReportEntry/getLabReportEntryList";

//192.168.29.102:8083/dairy-warna/transaction/labReportEntry/saveLabReportEntry
export const saveLabDetailsAPIURL = BaseUrl + "/transaction/labReportEntry/saveLabReportEntry";

//updateLabReportEntry
export const updateLabDetailsAPIURL = BaseUrl + "/transaction/labReportEntry/updateLabReportEntry";

//http://192.168.195.102:8083/dairy-warna/transaction/gateEntry/getGateEntryByUniqueId?uniqueId=28112025152111
export const getGateEntryDetailsByUniqueId = BaseUrl + "/transaction/gateEntry/getGateEntryByUniqueId";

